import { Business } from '../types/businessTypes';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { businesses, BusinessConfig } from '../../config/businesses';

const initialState: Business = {
  departments: [],
  availableBusinesses: businesses, // ✅ INICIALIZAR CON EMPRESAS DISPONIBLES
  getUsersStatus: {
    loading: false,
    success: false,
    error: false,
  },
};

const BusinessSlice = createSlice({
  name: 'business',
  initialState,
  reducers: {
    login: (state: Business, action: PayloadAction<Partial<Business>>) => {
      return {
        ...state,
        ...action.payload,
      };
    },
    logout: () => {
      return {
        ...initialState,
      };
    },
    refreshFromRemote: (
      state: Business,
      action: PayloadAction<BusinessConfig[]>
    ) => {
      const fresh = action.payload;
      if (fresh.length === 0) {
        return state;
      }

      const refreshedCurrent =
        state.id != null ? fresh.find(b => b.id === state.id) : undefined;

      return {
        ...state,
        availableBusinesses: fresh,
        ...(refreshedCurrent && refreshedCurrent.departments.length > 0
          ? {
              name: refreshedCurrent.name,
              subdomain: refreshedCurrent.subdomain,
              departments: refreshedCurrent.departments,
            }
          : {}),
      };
    },
    successGetUsers: (state: Business, action: PayloadAction<any[]>) => {
      return {
        ...state,
        users: [...action.payload],
        getUsersStatus: { loading: false, success: true, error: false },
      };
    },
    loadingGetUsers: (state: Business) => {
      return {
        ...state,
        getUsersStatus: { loading: true, success: false, error: false },
      };
    },
    errorGetUsers: (state: Business) => {
      return {
        ...state,
        getUsersStatus: { loading: false, success: false, error: true },
      };
    },
  },
});

export const businessActions = BusinessSlice.actions;
export const businessReducer = BusinessSlice.reducer;
